import styled from "styled-components";

export const Bio = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BioSubHeading = styled.p`
  margin: 1.5rem 0 3rem 0;
  font-size: 1.5rem;

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`;
